import AboutUsPage from "@/components/about-us/AboutUsPage";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

const AboutUs = ({ type }) => {
    return isProspect(type) ? <AboutUsPage /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default AboutUs;
